import { enCompanyDataPageTranslation } from './company-data';

export const enYourDataPageTranslation = {
  your_data: {
    ...enCompanyDataPageTranslation,
  },
};
